import React, {useEffect, useMemo, useState, useRef} from "react";
import {Button} from "react-bootstrap";
import "./../../src/component/DistanceCalculator/main.css";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import {toast} from "react-toastify";
import Loader from "../Loader/Loader";
import DropDownInput from "./Input/dropDownInput/dropDownInput";
import localStorage from "redux-persist/es/storage";
import LastActivityModal from "./Parking/Activity/LastActivityModal/lastActivityModal";
import FailedModal from "./CustomModal/Failed";
import { useHistory } from 'react-router-dom';
import Config from "../service/Config/config";
import callWebService, {callTypes} from "../../src/service/Networks/network.js";
import distanceBetweenTwoPoints from "./DistanceBetweenTwoPoints";
import {generateRandomString} from "./Common";
import geocode, {appendLocationInImage} from "./Geocode";

const DistanceCalculatorV2 = ({
                                moduleType,
                                isMapShow = true,
                                calculateDistance,
                                checkInText = "Check In",
                                checkoutId,
                                moduleId = "",
                                activityId = "",
                                documentUploadUrlPublic = () => {},
                                documentUrlDataPublic = [],
                                showSelfie = true,
                                attendanceResponse = [],
                                accountId = "",
                                module_name = "",
                                isPendingActivityCheckRequired = true,
                                locationLatAndLng = "",
                                hideCheckButton = false,
                                distance = "",
                                leadId = 0,
                                dealerId = "",
                                lat = "",
                                long = "",
                                opportunity_id = "",
                                allowCheckOutOnMissingMeeting = false,
                                onSuccess = "",
                                onError = "",
                                valetProjectId = "",
                                showTaggedAlong = false,
                                taggedAlongList = [],
                                projectType = 0,
                                pjpId = '',
                                deviceId = '',
                                deviceIdCheck = false,
                            }) => {
    let markers = [];
    const [mapLocation, setMapLocation] = useState({
        address: "Delhi",
        formatted_address: null,
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const canvasRef = useRef(null);
    const currentUserLocation = useRef(null);
    const [comments, setComments] = useState("");
    const [selfie, setSelfie] = useState(false);
    const [selfieUrl, setSelfieUrl] = useState("");
    const [retake, setRetake] = useState(true);
    const [roleId, setRoleId] = useState("");
    const [resetSelfie, setResetSelfie] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [taggedAlongValue, setTaggedAlongValue] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [currentLat, setCurrentLat] = useState('')
    const [currentLong, setCurrentLong] = useState('')
    const [showLastActivities,setShowLastActivities]=useState(false)
    const [redirectUrl,setRedirectUrl]=useState('');
    const [previousActivities,setPreviousActivities]=useState([]);
    const [showPendingRatingActivity,setShowPendingRatingActivity]=useState(false)
    const [pendingActivitiesText,setPendingActivitiesText]=useState('');
    const history = useHistory();

    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null)

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    useEffect(  () => {
        (async () => {
            const webView = window.localStorage?.webview;
            if(webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        })();
    }, []);


    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        setIsLocationFetching(false);
                        reject('Location access denied.');
                    } else {
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
        setIsLoading(false);
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = await localStorage.getItem('token');
                const base_url = process.env.REACT_APP_API_URL;
                const moduleType = await localStorage?.getItem('module_type')||'';
                const response = await callWebService(callTypes.get, '', `${Config?.getPreviousActivities}?opportunity_id=${opportunity_id}&account_id=${accountId}&lead_id=${leadId}&dealer_id=${dealerId}&valet_project_id=${valetProjectId}&based_on_assign_to=${true}&module_type=${moduleType}`);
                if (response !== null && response?.data !== null && response?.data?.response !== null) {
                    const responseData = response?.data?.response?.data;
                    if (responseData?.has_pending_activity == true) {
                        setShowPendingRatingActivity(true);
                        setShowLastActivities(false);
                        setPendingActivitiesText(responseData?.pending_activities_text);
                    } else if (moduleType !== 'Fasttag Toll' && responseData?.activities?.length > 0) {
                        setPreviousActivities(responseData.activities);
                        setShowLastActivities(true);
                        setShowPendingRatingActivity(false);
                    } else {
                        setShowPendingRatingActivity(false);
                        setShowLastActivities(false);
                    }
                }
            }catch(error) {
                setIsLoading(false)
                console.error('Failed to fetch locations:', error);
                return;
            }
        };
        setIsLoading(true)

        if(checkInText == "Check In"){
            fetchData()
        }
        setIsLoading(false)

    },[checkInText, opportunity_id,accountId,leadId])

    useEffect(() => {
        setCurrentLat(currentUserLocation?.current?.lat);
        setCurrentLong(currentUserLocation?.current?.long);
        if((currentUserLocation?.current?.lat !== undefined && currentUserLocation?.current?.long !== undefined) && (currentUserLocation?.current?.lat !== 0 && currentUserLocation?.current?.long !== 0) && (currentUserLocation?.current?.lat !== null && currentUserLocation?.current?.long !== null)){
            let dis = distanceBetweenTwoPoints(lat, currentUserLocation?.current?.lat, long, currentUserLocation?.current?.long);
            if(dealerId && parseInt(dis) > 0.10){
                hideCheckButton = true
            } else if(leadId && parseInt(dis) > 0.3) {
                hideCheckButton = true
            }
        } else{
            console.log("currentUserLocation.current 123", currentUserLocation.current)
        }
    },[currentUserLocation?.current?.lat, currentUserLocation?.current?.long])


    useEffect(() => {
        if (selfie !== '' && canvasRef.current) {
            const canvas = canvasRef.current;
            (async () => {
                setIsLoading(true);
                const address = await geocode(currentUserLocation?.current?.lat, currentUserLocation?.current?.long);
                appendLocationInImage(currentUserLocation?.current?.lat, currentUserLocation?.current?.long, address, canvas, selfie, documentUploadUrlPublic);
                setIsLoading(false);
            })();
        }
    }, [selfie]);

    useEffect(() => {
        setRoleId(window.localStorage.role_id);
        if (checkInText === "Check out") {
            setTimeout(() => {
                setSelfieUrl("");
            }, 1000);
        }
    }, []);

    useEffect(() => {
        if (documentUrlDataPublic?.file_url !== undefined) {
            setSelfieUrl(documentUrlDataPublic?.file_url);
        }
    }, [documentUrlDataPublic]);

    const handleDeviceCheck = async (deviceId, id, activityId) => {
        let  device_id = '';
        if(window.localStorage.device_id){
            device_id = window.localStorage.device_id;
        } else {
            device_id = deviceId;
        }

        const base_url = process.env.REACT_APP_API_URL;
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": await localStorage.getItem("token")
            }};
        if(!deviceIdCheck){
            return true;
        }

        const response = await callWebService(callTypes.get,'',
            `${Config?.checkDeviceId}?device_id=${device_id}&id=${id}&activity_id=${activityId}`
        );

        if (response.data.status === true) {
            return response?.data?.response?.data
        }
    }

    const memoizedCameraComponent = useMemo(() => {
        return (
            <Camera
                idealFacingMode={"user"}
                idealResolution={{ width: 600, height: 480 }}
                onTakePhoto={(dataUri) => {
                    setSelfie(dataUri);
                    setRetake(false);
                }}
            />
        );
    }, [retake]);
    useEffect(() => {
        // Function to check window width and update state
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Define the breakpoint for mobile
        };

        // Initial check on component mount
        handleResize();

        // Add event listener to detect window resize
        window.addEventListener('resize', handleResize);

        // Cleanup on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (isAllow) {
            toast.error("In order to submit the form you need to allow the location first");
            return false;
        }

        const data = {
            lat: currentUserLocation?.current?.lat || locationLatAndLng?.lat || null,
            long: currentUserLocation?.current?.long || locationLatAndLng?.lng || null,
            module_type: moduleType,
            comments,
            check_type: "in",
            id: checkoutId,
            selfie: selfieUrl,
            account_id: accountId,
            opportunity_id,
            device_id: window.localStorage.device_id || deviceId || currentUserLocation?.current?.device_id || '',
            pjp_id: pjpId || undefined,
            lead_id: leadId || undefined,
            allow_check_out_on_missing_meeting: allowCheckOutOnMissingMeeting,
            is_pending_activity_check_required: isPendingActivityCheckRequired,
            module_name: module_name || undefined,
            tagged_along: Array.isArray(taggedAlongValue) ? taggedAlongValue.map(v => v.id) : undefined,
            device_info: window.localStorage?.webview
                ? {
                    brand_name: window.localStorage?.brand_name,
                    model_name: window.localStorage?.model_name,
                    device_name: window.localStorage?.device_name,
                    device_os: window.localStorage?.device_os,
                    device_os_version: window.localStorage?.device_os_version,
                }
                : null,
            dealer_id: moduleType === "Dealer" ? moduleId : undefined,
            valet_project_id: moduleType === "valet" ? valetProjectId : undefined,
            activity_id: activityId || undefined,
        };

        if (!data.lat || !data.long) {
            toast.error("Please enable your location");
            return false;
        }

        if (selfieUrl === "" && checkInText === "Check In" && parseInt(roleId) !== 42) {
            toast.error("Please take a selfie");
            return false;
        }

        if (checkInText === "Check out") {
            const response = await handleDeviceCheck(deviceId, checkoutId, activityId);
            if (!response) {
                toast.error("Check-in device and check-out device must be the same");
                return false;
            }
            data["check_type"] = "out";
        }

        setIsLoading(true);
        let res = await calculateDistance(data);
        if (!isMapShow) window.location.reload();
        setSelfie('');
        setIsLoading(false);
    };


    const handleModalClose = () => {
        setIsLoading(true)
        setShowLastActivities(false);
        setIsLoading(false)
    };

    const handlePendingActivityModalClose = () => {
        setIsLoading(true)
        setShowPendingRatingActivity(false)
        history.goBack()
        setIsLoading(false)
    };

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if(webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            setLocationStatus('granted')
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }
    return (
        <>
            {showPendingRatingActivity ? (
                <FailedModal
                    isOpen = {showPendingRatingActivity}
                    msg={pendingActivitiesText}
                    handleModalHide={
                        handlePendingActivityModalClose
                    }
                >

                </FailedModal>
            ):(
                <>
                    <Loader isLoading={isLoading} />
                    <link
                        rel="stylesheet"
                        href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
                        integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
                        crossOrigin="anonymous"
                    />
                    <link
                        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700"
                        rel="stylesheet"
                    ></link>
                    {/* {console.log("showPendingRatingActivity",showPendingRatingActivity)}
        {console.log("pendingRatingActivity",pendingRatingActivity)} */}
                    {showPendingRatingActivity &&
                        <FailedModal
                            isOpen = {showPendingRatingActivity}
                            msg={pendingActivitiesText}
                            handleModalHide={
                                handlePendingActivityModalClose
                            }
                        >

                        </FailedModal>
                    }
                    {showLastActivities && previousActivities && previousActivities.length>0 &&
                        <LastActivityModal
                            title={`Last Activity's MOM`}
                            activities={previousActivities.map(act => {
                                // Extracting product and service details
                                const product = act.meta_data?.[0]?.product?.[0]?.name
                                const serviceDetails = act.meta_data?.[0]?.service_details?.find(service => service.selected);
                                const solutionDetails = act.meta_data?.[0]?.solution_details?.find(solution => solution.selected);
                                const formattedReason = Array.isArray(act?.reason)
                                    ? act?.reason?.[0]?.reason
                                    : act?.reason;
                                return {
                                    activity_type:act.activity_type,
                                    project_type_name:act.project_type_name,
                                    assigned_to_name:act.assigned_to_name,
                                    mom: act.meta_data?.[0]?.MOM||act.meta_data?.[0]?.mom,
                                    introduction: act.meta_data?.[0]?.Introduction,
                                    meetingType: act.meta_data?.[0]?.Meeting_Type,
                                    remark: act.meta_data?.[0]?.remark,
                                    tagged_along_name: act?.tagged_along_name,
                                    activity_date: act?.activity_date,
                                    description: act?.description,
                                    meeting_outcome: act?.meeting_outcome?.[0]?.Outcome,
                                    purpose_of_visit: act?.purpose_of_visit?.[0]?.visit_purpose,
                                    reason: formattedReason,
                                    product: product,
                                    serviceId: serviceDetails?.id,
                                    solutionId: solutionDetails?.id,
                                    valet_client_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Client_Mom,
                                    sub_activity_type:act?.sub_activity_type,
                                    comment:act?.meta_data?.[0]?.Comment,
                                    internal_mom:act?.meta_data?.[0]?.internal_mom,
                                    payment_collection_mom: act?.meta_data?.[0]?.payment_collection_details?.[0]?.payment_collection_mom,
                                    relationship_meeting_mom:act?.meta_data?.[0]?.relationship_meeting_details?.[0]?.relationship_meeting_mom,
                                    meeting_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Meeting_MoM
                                };
                            })}
                            show={showLastActivities}
                            handleModalHide={() => {
                                handleModalClose();
                                // setOpenCheckIn(true)
                            }}
                        />
                    }
                    <div className="col-12"><><h3 style={{"color":"#000000"}}>{checkInText}
                        <div style={{"float":"right"}}><small>{dealerId && (
                            <>
                                Dealer : {dealerId}
                            </>
                        )}
                            {leadId !== "" && leadId !== 0 && (
                                <>
                                    Lead : {leadId}
                                </>
                            )}
                        </small>
                        </div>
                    </h3></></div>
                    <form className="attForm" style={{"margin-top":"auto"}}>
                        <div className="row pointer-where-are-you">

                            <div className="col-m-6">
                                {/*<Speed />*/}
                                <div>
                                    <div>{
                                        isLocationFetching ? "Location fetching..." : ""
                                    }</div>
                                </div>
                                <div style={{color: "dodgerblue"}}>
                                    {lat && (
                                        <>
                                            {currentUserLocation?.current?.lat &&
                                                <p className="text-bold text-warning">{parseFloat(distanceBetweenTwoPoints(lat, currentUserLocation?.current?.lat, long, currentUserLocation?.current?.long)).toFixed(2)} km
                                                    away from site</p>
                                            }

                                            Site Location : {`${lat} , ${long}`}
                                        </>
                                    )}

                                </div>
                                <div className="d-flex justify-content-center align-items-center">{
                                    locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                        <div>Your Location
                                            : {`${currentUserLocation?.current?.lat} , ${currentUserLocation?.current?.long}`}</div> :
                                        <div>
                                            <div>You've denied GPS/permission, please allow it and then relaunch the
                                                application
                                            </div>
                                        </div>
                                }
                                    <button className="btn-sm float-right
                                            btn btn-primary" id="fetchLocation" onClick={(e) => refreshUserLocation(e)}
                                    >
                                        <i className="bi bi-arrow-clockwise f-20px"></i></button>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-12">
                                {showSelfie && parseInt(roleId) !== 42 && (
                                    <>
                                        <div className="col-12">
                                            <div className="map">
                                                {/*google-map*/}
                                                <div className="">
                                                    {/*{(mapLocation && mapLocation.lat &&*/}
                                                    {/*    <GoogleMapReact*/}
                                                    {/*        bootstrapURLKeys={{key: 'AIzaSyBlmRvuUm34c6KzlQ3-HrXJJY0WoNPYV8Y'}}*/}
                                                    {/*        defaultCenter={mapLocation}*/}
                                                    {/*        defaultZoom={15}*/}
                                                    {/*        yesIWantToUseGoogleMapApiInternals*/}
                                                    {/*        onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}*/}
                                                    {/*    >*/}
                                                    {/*    </GoogleMapReact>*/}
                                                    {/*)}*/}
                                                    <canvas
                                                        ref={canvasRef}
                                                        width="100%"
                                                        height="520"
                                                        style={{ display: 'none', border: '1px solid black', marginTop: '20px' }}
                                                    ></canvas>
                                                    {selfieUrl !== "" ? (
                                                        <img style={{width:"100%"}} src={`${selfieUrl}`} />
                                                    ) : (
                                                        retake && memoizedCameraComponent
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            {checkInText === 'Check In' && (parseInt(projectType) === 2 || parseInt(projectType) === 1 || parseInt(projectType) === 3) && showTaggedAlong &&
                                <div className="col-sm-12 col-md-12 mtk-075 float-field mb-4">
                                    <label>Tag Along </label>
                                    <DropDownInput
                                        data={taggedAlongList}
                                        label={' '}
                                        getIdValue={(val) => {
                                            setTaggedAlongValue(val)
                                        }}
                                        multipule={true}
                                        hideLabel={true}
                                        required={true}
                                    />
                                </div>
                            }

                            <div className="col-12">
              <textarea
                  className="form-control form-control-user"
                  placeholder=" Description"
                  onChange={(e) => {
                      setComments(e.target.value);
                  }}
                  id="validationCustom01"
                  rows="4"
                  cols="50"
              />
                                <label className="large-label float-lb">{/*Description*/}</label>
                            </div>


                            {isMobile ?
                                <div className="col-3 d-flex">
                                    {currentUserLocation?.current?.lat && !hideCheckButton && (
                                        <Button className="btn-sm" onClick={(e) => handleSubmitData(e)}>
                                            {"Submit"}
                                        </Button>
                                    )}
                                    {showSelfie && parseInt(roleId) !== 42 && (
                                        <Button
                                            className="btn-sm float-right"
                                            style={{ marginLeft: "36%" }}
                                            onClick={() => {
                                                setRetake(true);
                                                setSelfieUrl("");
                                                setSelfie("");
                                            }}
                                        >
                                            {"Retake"}
                                        </Button>
                                    )}
                                </div>

                                :
                                <div className="col-12" style={{"color" : "red"}}>Checkin is disable on desktop mode</div>
                            }

                        </div>
                    </form>
                </>
            )}
        </>
    );
};

export default DistanceCalculatorV2;
